import { newPermissions } from '@shared/newPermissions';

import { UnitPaymentLogsPage, UserPaymentLogsPage } from './components';
import {
  ROUTE_UNIT_PAYMENT_LOGS,
  ROUTE_USER_PAYMENT_LOGS,
} from './duck/actions';

const routes = {
  [ROUTE_UNIT_PAYMENT_LOGS]: {
    path: '/unitPaymentLogs',
    Component: UnitPaymentLogsPage,
    titleId: 'page.unitPaymentLogs',
    permission: newPermissions.CRUD_UNIT_LOG,
  },
  [ROUTE_USER_PAYMENT_LOGS]: {
    path: '/paymentLogs/:userId',
    Component: UserPaymentLogsPage,
    titleId: 'page.memberPaymentLogs',
  },
};

export default routes;
